<template>
    <swiper :options="swiperOptions">
        <!--todo 禮包增加樣式giftPack-->
        <swiper-slide  class="goods-item" v-for="(item, index) in list.slice(0, PreviewNum)" :key="index" @click.native.stop="onClick(item, index)">
            <div class="cover">
                <el-image
                        :src="item.path"
                        fit="cover"/>
            </div>
            <div class="title">
                {{item.name}}
            </div>
            <div class="fee">${{item.price}}</div>
        </swiper-slide>
    </swiper>
</template>

<script>
    /*todo 輪播組件Swiper只支援vue3，要另外用外掛vue-awesome-swiper
       demo https://github.surmon.me/vue-awesome-swiper/
       swiper4-6功能中文網 https://www.swiper.com.cn/api/autoplay/19.html*/
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {
        name: "SliderProduct",
        props: [
            'list',
            'PreviewNum' //預覽時抓取的筆數
        ],
        components: {
            Swiper,
            SwiperSlide,
        },
        computed: {

        },
        data() {
            return {
                //輪播用
                swiperOptions: {
                    loop: false,
                    spaceBetween: 20,
                    slidesOffsetBefore : 20,
                    slidesPerView: 'auto',
                    touchMoveStopPropagation : true,//阻止touchmove冒泡事件
                },
            }
        },
        mounted() {

            //商品結構
            // cartList": [
            // {
            //     "amount": 2,
            //     "id": 22,
            //     "path": "",
            //     "price": 2600,
            //     "sold": 0,  //sold = amount : 售完
            //     "status": 0  //0:下架,1:啟用
            // }, …

        },
        methods: {
            onClick: function(item, index) {
                // this.$router.push({name: 'Product'});
                this.$emit('onItemClick', {
                    object: item,
                    index: index,
                })
            }
        }

    }
</script>

<style scoped lang="less">
    //輪播用
    .swiper-slide:first-child{
        @media(min-width: 768px){
            margin-left: 20px;
        }
    }
    .goods-item{
        width: 130px !important;
        @media (min-width: 1024px){
            cursor: pointer;
            &:hover{
                opacity: .7;
            }
        }
    }
</style>
